import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import { UpdateUserRow, UserRow } from "./user.type";

export const getUser = async (): Promise<UserRow> => {
  try {
    const slug = ApiEndpoints.user + "/client";

    const options = await setHeaderOptions({
      method: "GET",
    });
    const user = await fetchData<UserRow>(slug, options);

    return user;
  } catch (err) {
    console.error("Error getting user:", err);
    throw err;
  }
};

export const updateUser = async (
  user: UpdateUserRow,
  contactId?: string,
  relatedUserRole?: string
): Promise<UserRow> => {
  try {
    const slug = ApiEndpoints.user;

    const body = {
      ...user,
      ...(contactId && { contact_id: contactId }),
      ...(relatedUserRole && { related_user_role: relatedUserRole }),
    };

    const options = await setHeaderOptions({
      method: "PUT",
      body,
    });
    const updatedLead = await fetchData<UserRow>(slug, options);

    return updatedLead;
  } catch (err) {
    console.error("Error updating lead:", err);
    throw err;
  }
};

export type UserSearchParameters = {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  patientId?: string | null;
  dateOfBirth?: string | null;
};

type UserSearchResponse = {
  data: UserRow[];
  error: string | null;
};

export const getUsersByParameters = async (
  params: UserSearchParameters & {
    email_summary?: {
      patient_email?: string | null;
      patient_first_name?: string | null;
      patient_last_name?: string | null;
      patient_dob?: string | null;
    };
    metadata?: { patientId?: string | null; patient_id?: string | null };
    objectMetadata?: { patientId?: string | null; patient_id?: string | null };
  }
): Promise<UserRow[]> => {
  const body: Record<string, unknown> = {
    ...params,
    email_summary: params.email_summary,
    metadata: params.metadata,
    objectMetadata: params.objectMetadata,
    dateOfBirth: params.dateOfBirth,
  };

  const options = await setHeaderOptions({
    method: "POST",
    body,
  });

  const res = await fetchData<UserSearchResponse | UserRow[]>(
    "/inbound-document-jobs/user-search",
    options
  );
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  return [];
};
